(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dart-solo-product-finder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dart-finder').forEach(function (finder) {
    var input = finder.querySelector('.dart-finder__input');
    var form = finder.querySelector('.dart-finder__form');
    var results = finder.querySelector('.dart-finder__results');
    var catalogUrl = finder.dataset.catalogUrl;
    var catalog = [];
    var stopWords = ['a', 'an', 'and', 'are', 'can', 'do', 'for', 'from', 'get', 'i', 'in', 'is', 'it', 'me', 'need', 'of', 'or', 'show', 'that', 'the', 'to', 'what', 'which', 'with', 'you', 'your'];
    function isUseful(word) { return stopWords.indexOf(word) === -1 && (word.length > 1 || /\d/.test(word)); }
    function escapeHtml(value) { return value.replace(/[&<>'"]/g, function (character) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]; }); }
    function searchable(item) { var attributes = Object.entries(item.attributes || {}).reduce(function (values, entry) { return values.concat(entry[0], String(entry[1])); }, []); return [item.sku, item.manufacturerSku, item.brand, item.name, item.line, item.material, item.color, item.temperatureRange, item.relatedProducts, item.description].concat(item.bullets || [], attributes).join(' ').toLowerCase(); }
    function facts(item) { var values = []; if (item.itemsPerCase) values.push(item.itemsPerCase + ' items per case'); if (item.sleevesPerCase) values.push(item.sleevesPerCase + ' sleeves per case'); if (item.material) values.push(item.material); if (item.color) values.push(item.color); return values.slice(0, 4); }
    function measurements(item) { var values = []; var product = []; if (item.caseLength && item.caseWidth && item.caseHeight) values.push(['Box dimensions', item.caseLength + ' × ' + item.caseWidth + ' × ' + item.caseHeight + ' in (L × W × H)']); else if (item.caseDimensions) values.push(['Box dimensions', item.caseDimensions + ' in']); if (item.productLength && item.productWidth && item.productHeight) values.push(['Product dimensions', item.productLength + ' × ' + item.productWidth + ' × ' + item.productHeight + ' in (L × W × H)']); else { if (item.topDiameter) product.push('Top diameter ' + item.topDiameter + ' in'); if (item.baseDiameter) product.push('Base diameter ' + item.baseDiameter + ' in'); if (item.lidDiameter) product.push('Lid diameter ' + item.lidDiameter + ' in'); if (item.productHeight) product.push('Height ' + item.productHeight + ' in'); if (product.length) values.push(['Product dimensions', product.join(' · ')]); } if (item.practicalCapacity) values.push(['Practical capacity', item.practicalCapacity + ' oz']); else if (item.flushFillCapacity) values.push(['Flush-fill capacity', item.flushFillCapacity + ' oz']); return values; }
    function dimensionAnswer(item, query) { var box = /box|case|carton|shipping/.test(query); var lid = /lid/.test(query); var dimension = /dimension|size|diameter|measure|height|width|length/.test(query); var values; if (!dimension && !box) return ''; values = measurements(item); if (box) values = values.filter(function (value) { return value[0] === 'Box dimensions'; }); else if (lid) values = values.filter(function (value) { return value[0] === 'Product dimensions'; }); if (!values.length) return ''; return '<div class="dart-finder__answer">' + values.map(function (value) { return '<strong>' + value[0] + ':</strong> ' + value[1]; }).join('<br>') + '</div>'; }
    function attributeAnswers(item, query) { var normalized = query.replace(/[^a-z0-9]/g, ''); var queryWords = query.match(/[a-z0-9]+/g) || []; var keyTerms = ['upc', 'gtin', 'capacity', 'weight', 'material', 'description', 'temperature', 'origin', 'color', 'recyclability']; return Object.entries(item.attributes || {}).filter(function (entry) { var label = entry[0]; var labelWords = label.toLowerCase().match(/[a-z0-9]+/g) || []; var labelNormalized = label.toLowerCase().replace(/[^a-z0-9]/g, ''); return normalized.indexOf(labelNormalized) !== -1 || labelWords.some(function (word) { return keyTerms.indexOf(word) !== -1 && queryWords.indexOf(word) !== -1; }); }).slice(0, 8); }
    function detailList(item) { return '<details class="dart-finder__details"><summary>View all catalog details</summary><dl>' + Object.entries(item.attributes || {}).map(function (entry) { return '<div><dt>' + escapeHtml(entry[0]) + '</dt><dd>' + escapeHtml(String(entry[1])) + '</dd></div>'; }).join('') + '</dl></details>'; }
    function productImages(item) { var images = []; if (item.productImage) images.push(['Item image', item.productImage]); if (item.caseImage) images.push(['Closed case', item.caseImage]); if (!images.length) return ''; return '<div class="dart-finder__product-images">' + images.map(function (image) { return '<figure class="dart-finder__product-image"><img loading="lazy" src="' + escapeHtml(image[1]) + '" alt="' + escapeHtml(item.sku + ' ' + image[0]) + '"><figcaption>' + image[0] + '</figcaption></figure>'; }).join('') + '</div>'; }
    function contactLink(item) { return 'https://wa.me/19088002461?text=' + encodeURIComponent('Hi Prima Supply, I would like information about Dart/Solo item ' + item.sku + ' (' + item.name + '). Can you confirm availability and pricing?'); }
    function search() {
      var query = input.value.trim().toLowerCase();
      if (!query) { return; }
      var words = (query.match(/[a-z0-9]+/g) || []).filter(isUseful);
      var plainQuery = query.replace(/[^a-z0-9]/g, '');
      var found = catalog.map(function (item) { var haystack = searchable(item); var score = 0; if (plainQuery === item.sku.toLowerCase().replace(/[^a-z0-9]/g, '') || plainQuery === item.manufacturerSku.toLowerCase().replace(/[^a-z0-9]/g, '')) score = 10000; words.forEach(function (word) { if (item.sku.toLowerCase().indexOf(word) !== -1 || item.manufacturerSku.toLowerCase().indexOf(word) !== -1) score += 120; else if (item.name.toLowerCase().indexOf(word) !== -1) score += 30; else if (item.line.toLowerCase().indexOf(word) !== -1) score += 15; else if (haystack.indexOf(word) !== -1) score += 4; }); return { item: item, score: score }; }).filter(function (match) { return match.score > 0; }).sort(function (a, b) { return b.score - a.score || a.item.sku.localeCompare(b.item.sku); }).slice(0, 12).map(function (match) { return match.item; });
      if (!found.length) { results.innerHTML = '<div class="dart-finder__empty"><span class="dart-finder__empty-icon" aria-hidden="true">?</span><div><strong>No catalog match found</strong><p>Try the manufacturer item number, product type, size, material, or case pack.</p></div></div>'; return; }
      results.innerHTML = '<p class="dart-finder__result-label">' + found.length + ' catalog match' + (found.length === 1 ? '' : 'es') + ' for “' + escapeHtml(input.value.trim()) + '”</p><div class="dart-finder__result-list">' + found.map(function (item) { var answers = attributeAnswers(item, query); return '<article class="dart-finder__result"><span class="dart-finder__sku">' + escapeHtml(item.sku) + '</span><div><h2 class="dart-finder__name">' + escapeHtml(item.name) + '</h2><p class="dart-finder__line">' + escapeHtml(item.brand + (item.line ? ' · ' + item.line : '')) + '</p>' + productImages(item) + dimensionAnswer(item, query) + (answers.length ? '<div class="dart-finder__answer">' + answers.map(function (entry) { return '<strong>' + escapeHtml(entry[0]) + ':</strong> ' + escapeHtml(String(entry[1])); }).join('<br>') + '</div>' : '') + '<ul class="dart-finder__facts">' + facts(item).map(function (fact) { return '<li>' + escapeHtml(fact) + '</li>'; }).join('') + '</ul>' + (item.relatedProducts ? '<p class="dart-finder__notice">Related catalog products: ' + escapeHtml(item.relatedProducts) + '</p>' : '') + '<a class="dart-finder__contact" href="' + contactLink(item) + '" target="_blank" rel="noopener">Ask us about this item on WhatsApp</a>' + detailList(item) + '</div></article>'; }).join('') + '</div><p class="dart-finder__notice">Catalog specifications only. Availability, prices, and compatibility are confirmed by our team.</p>';
    }
    fetch(catalogUrl).then(function (response) { if (!response.ok) throw new Error('Catalog unavailable'); return response.json(); }).then(function (payload) { catalog = payload.records || []; finder.querySelector('.dart-finder__empty p').textContent = catalog.length + ' Dart and Solo catalog records are ready to search.'; }).catch(function () { finder.querySelector('.dart-finder__empty p').textContent = 'The catalog is temporarily unavailable. Please try again shortly.'; });
    form.addEventListener('submit', function (event) { event.preventDefault(); search(); });
    finder.querySelectorAll('[data-finder-query]').forEach(function (button) { button.addEventListener('click', function () { input.value = button.dataset.finderQuery; search(); }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prima-item-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('prima-sku-search')) {
    customElements.define('prima-sku-search', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        this.form = this.querySelector('form');
        this.results = this.querySelector('.prima-finder__results');
        this.catalog = null;
        this.timer = null;
        this.requestNumber = 0;
        this.input.addEventListener('input', () => {
          window.clearTimeout(this.timer);
          this.timer = window.setTimeout(() => this.search(), 220);
        });
        this.input.addEventListener('keydown', (event) => this.onKeydown(event));
        this.form.addEventListener('submit', (event) => {
          const exactLink = this.results.querySelector('[data-exact-match]');
          if (exactLink) {
            event.preventDefault();
            window.location.assign(exactLink.href);
          }
        });
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.close();
        });
      }

      normalize(value) {
        return String(value || '').toLowerCase().replace(/^(drt|dart|solo)/, '').replace(/[^a-z0-9]/g, '');
      }

      async loadCatalog() {
        if (this.catalog) return this.catalog;
        const response = await fetch(this.dataset.catalogUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(String(response.status));
        const data = await response.json();
        this.catalog = Array.isArray(data.products) ? data.products : [];
        return this.catalog;
      }

      isDartSolo(product, variant) {
        const identity = `${product.vendor || ''} ${product.title || ''} ${variant.sku || ''}`.toLowerCase();
        return identity.includes('dart') || identity.includes('solo') || identity.includes('drt#');
      }

      productUrl(product) {
        return product.url || `/products/${product.handle}`;
      }

      productImage(product) {
        const image = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
        return typeof image === 'string' ? image : image && image.src ? image.src : '';
      }

      price(product, variant) {
        const rawPrice = variant && variant.price !== undefined ? variant.price : product.price;
        let amount = Number(rawPrice);
        if (typeof rawPrice === 'number') amount = amount / 100;
        if (!Number.isFinite(amount)) return '';
        return new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(amount);
      }

      async compatibleProducts(product) {
        const url = `${this.dataset.recommendationsUrl}?product_id=${encodeURIComponent(product.id)}&limit=6&intent=complementary`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) return [];
        const data = await response.json();
        return (Array.isArray(data.products) ? data.products : []).filter((item) => {
          const variant = Array.isArray(item.variants) ? item.variants[0] : {};
          return this.isDartSolo(item, variant);
        }).slice(0, 3);
      }

      async search() {
        const enteredTerm = this.input.value.trim();
        const query = this.normalize(enteredTerm);
        const currentRequest = ++this.requestNumber;
        if (query.length < 3) {
          this.close();
          return;
        }
        this.input.setAttribute('aria-busy', 'true');
        try {
          const products = await this.loadCatalog();
          const matches = [];
          products.forEach((product) => {
            const variants = Array.isArray(product.variants) ? product.variants : [];
            const variant = variants.find((item) => this.isDartSolo(product, item) && this.normalize(item.sku).startsWith(query));
            if (variant) matches.push({ product, variant, exact: this.normalize(variant.sku) === query });
          });
          matches.sort((left, right) => Number(right.exact) - Number(left.exact) || Number(right.variant.available) - Number(left.variant.available) || String(left.variant.sku).localeCompare(String(right.variant.sku)));
          const exactMatch = matches.find((match) => match.exact);
          const compatible = exactMatch ? await this.compatibleProducts(exactMatch.product) : [];
          if (currentRequest !== this.requestNumber || this.normalize(this.input.value) !== query) return;
          this.render(enteredTerm, matches.slice(0, 6), compatible);
        } catch (error) {
          if (currentRequest === this.requestNumber) this.close();
        } finally {
          if (currentRequest === this.requestNumber) this.input.removeAttribute('aria-busy');
        }
      }

      createHeading(text) {
        const heading = document.createElement('p');
        heading.className = 'prima-finder-results__heading';
        heading.textContent = text;
        return heading;
      }

      createResult(product, variant, exact, compatibleLabel) {
        const item = document.createElement('li');
        item.className = `prima-finder-results__item${compatibleLabel ? ' prima-finder-results__item--compatible' : ''}`;
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        const link = document.createElement('a');
        link.className = 'prima-finder-results__link';
        link.href = this.productUrl(product);
        if (exact) link.dataset.exactMatch = 'true';
        const imageUrl = this.productImage(product);
        if (imageUrl) {
          const image = document.createElement('img');
          image.className = 'prima-finder-results__image';
          image.src = imageUrl;
          image.alt = product.title || '';
          image.loading = 'lazy';
          link.append(image);
        }
        const information = document.createElement('span');
        const title = document.createElement('span');
        title.className = 'prima-finder-results__title';
        title.textContent = product.title || '';
        const sku = document.createElement('span');
        sku.className = 'prima-finder-results__sku';
        sku.textContent = `Item # ${variant.sku || ''}${exact ? ' · Exact match' : compatibleLabel ? ' · Sold separately' : ''}`;
        information.append(title, sku);
        const price = document.createElement('span');
        price.className = 'price';
        price.textContent = this.price(product, variant);
        link.append(information, price);
        item.append(link);
        return item;
      }

      render(term, matches, compatible) {
        this.results.replaceChildren();
        if (!matches.length) {
          this.close();
          return;
        }
        const exact = matches.find((match) => match.exact);
        this.results.append(this.createHeading(exact ? 'Exact match' : 'Dart & Solo products'));
        const list = document.createElement('ul');
        list.className = 'prima-finder-results__list';
        list.setAttribute('role', 'listbox');
        if (exact) list.append(this.createResult(exact.product, exact.variant, true, false));
        if (exact && compatible.length) {
          const group = document.createElement('li');
          group.className = 'prima-finder-results__group';
          group.setAttribute('role', 'presentation');
          group.textContent = `Compatible with ${exact.variant.sku.replace(/^DRT#/i, '')}`;
          list.append(group);
          compatible.forEach((product) => {
            const variant = Array.isArray(product.variants) ? product.variants[0] : {};
            list.append(this.createResult(product, variant, false, true));
          });
        }
        matches.filter((match) => !match.exact).forEach((match) => list.append(this.createResult(match.product, match.variant, false, false)));
        this.results.append(list);
        const all = document.createElement('a');
        all.className = 'prima-finder-results__all';
        all.href = `/search?q=${encodeURIComponent(term)}&type=product`;
        all.textContent = `Search for “${term}” →`;
        this.results.append(all);
        this.setAttribute('open', '');
        this.input.setAttribute('aria-expanded', 'true');
      }

      onKeydown(event) {
        const options = Array.from(this.results.querySelectorAll('[role="option"]'));
        if (!options.length || !['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(event.key)) return;
        if (event.key === 'Escape') {
          this.close();
          return;
        }
        const selected = options.findIndex((option) => option.getAttribute('aria-selected') === 'true');
        if (event.key === 'Enter' && selected >= 0) {
          event.preventDefault();
          options[selected].querySelector('a').click();
          return;
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const next = event.key === 'ArrowDown' ? (selected + 1) % options.length : (selected <= 0 ? options.length - 1 : selected - 1);
          options.forEach((option, index) => option.setAttribute('aria-selected', String(index === next)));
          options[next].scrollIntoView({ block: 'nearest' });
        }
      }

      close() {
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', 'false');
        this.results.replaceChildren();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
